import { render, staticRenderFns } from "./QualityChart.vue?vue&type=template&id=3b8b7bde&scoped=true"
import script from "./QualityChart.vue?vue&type=script&lang=js"
export * from "./QualityChart.vue?vue&type=script&lang=js"
import style0 from "./QualityChart.vue?vue&type=style&index=0&id=3b8b7bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b7bde",
  null
  
)

export default component.exports